// @ts-strict-ignore
import React from 'react'
import { Avatar, ListItemAvatar, ListItemIcon } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { DescriptionTwoTone, Check, VideocamTwoTone, Cancel } from '@mui/icons-material'
import LoadingIcon from 'components/LoadingIcon'

export interface IQuestionIconProps {
  index: number
  hasVideoAnswer: boolean
  hasTextAnswer: boolean
  isWorking: boolean
    hasError: boolean
}

function QuestionIcon(props: IQuestionIconProps) {
  const { hasVideoAnswer, hasTextAnswer, index, isWorking, hasError } = props
  const theme = useTheme()

  if (isWorking) {
    return (
      <ListItemIcon style={{ minWidth: 42 }}>
        <LoadingIcon />
      </ListItemIcon>
    )
  }

  if (hasError) {
    return (
      <ListItemIcon style={{ minWidth: 42 }}>
        <VideocamTwoTone />
        <div style={{ position: 'relative', bottom: -12, right: 10 }}>
          <Cancel color="error" style={{ height: 20, width: 20 }} />
        </div>
      </ListItemIcon>
    )
  }

  if (hasVideoAnswer) {
    return (
      <ListItemIcon style={{ minWidth: 42 }}>
        <VideocamTwoTone color="primary" />
        <div style={{ position: 'relative', bottom: -12, right: 10 }}>
          <Check color="primary" style={{ height: 20, width: 20 }} />
        </div>
      </ListItemIcon>
    )
  }

  if (hasTextAnswer) {
    return (
      <ListItemIcon style={{ minWidth: 42 }}>
        <DescriptionTwoTone color="primary" />
        <div style={{ position: 'relative', bottom: -12, right: 10 }}>
          <Check color="primary" style={{ height: 20, width: 20 }} />
        </div>
      </ListItemIcon>
    )
  }

  return (
    <ListItemAvatar style={{ minWidth: 42, position: 'relative' }}>
      <Avatar style={{ width: 30, height: 30, fontSize: theme.typography.body2.fontSize, fontWeight: 500, background: theme.palette.secondary[300] }}>
        {index}
      </Avatar>
    </ListItemAvatar>
  )
}

export default React.memo(QuestionIcon)
